import { ColumnSource, RowSource } from "@omegagrid/grid";
import { ColorTypes } from "@omegagrid/core";
import { msg } from "@omegagrid/localize";
import rp, { GridEditorAdapter, GridEditorOptions, RowData } from "@reporting/rp-app-host";
import { ModuleCode } from "@reporting/rp-types/accounting";
import { DimensionDefinition, PropertiesDefinition } from "@reporting/rp-types/definition";
import { ATTRIBUTE_TYPES } from "../types";

export class DimAttributesGridEditorAdapter extends GridEditorAdapter {

	private _columns: ColumnSource[];
	private _dimension: DimensionDefinition;

	constructor (
		private moduleCode: ModuleCode,
		private dim_num: number
	) { super() }

	async getColumns(): Promise<ColumnSource[]> {
		if (this._columns) return this._columns;
		this._columns = [{
			t: 'a',
			e: false,
			w: 5 + 20 * 2,
			content: [{
				action: 'delete',
				title: msg('Delete'),
				icon: 'trash',
				color: ColorTypes.Red
			}, {
				action: 'duplicate',
				title: msg('Duplicate'),
				icon: 'copy',
				color: ColorTypes.Yellow
			}],
			filter: false,
			sorting: false,
		}, {
			data: 'key',
			header: msg('Key'),
			t: 't',
			e: true,
			w: 100
		}, {
			data: 'name',
			header: msg('Name'),
			t: 't',
			e: true,
			w: 100
		}, {
			data: 'type',
			header: msg('Type'),
			t: 's',
			e: true,
			w: 100,
			content: ATTRIBUTE_TYPES
		}, {
			data: 'format',
			header: msg('Format'),
			t: 't',
			e: true,
			filter: false,
			w: 100
		}];
		return this._columns;
	}

	async getRows(): Promise<RowSource[]> {
		this._dimension = await rp.ms('definition').get<DimensionDefinition>(`dimensions/${this.moduleCode}/${this.dim_num}`);
		if (!this._dimension) return Promise.reject('Dimension not found');;
		const props: PropertiesDefinition[] = this._dimension.properties;
		if (!props) return [];
		return props.map( data => ({ data }));
	}

	getOptions(): Partial<GridEditorOptions> {
		return this.createOptions({
			colLetters: false,
			columnSorting: true,
			refreshAfterSave: true,
			filters: true,
			saveMode: 'all_rows',
			pageSize: null,
			showEmptyRow: true,
			rowMenu: {
				addRows: true,
				deleteRows: true,
			},
		});
	}

	async save(rowData: RowData[]) {
		let data: PropertiesDefinition[] = rowData
			.filter(row => row.state !== 'deleted')
			.map(row => Object.assign(row.data));
		if (data.length === 0) {
			data = null;
		} else {
			const keys = data.map(item => item.key);
			const uniqueKeys = new Set(keys);
			if (keys.length !== uniqueKeys.size) {
				rp.host.bucket.showAlert({content: msg('Keys must be unique!'), type: 'warning'});
				return Promise.reject('Keys must be unique');
			}
			if (data.some(item => item.key.trim() === '')) {
				rp.host.bucket.showAlert({content: msg('Key cannot be empty!'), type: 'warning'});
				return Promise.reject('Key cannot be empty');
			}
		}
		this._dimension.properties = data;
		await rp.ms('definition').post('dimensions', this._dimension);
	}

}
